import {
  conspiracyOrganizedRecords,
  corporateRecords,
  destructionRecords,
  drugRecords,
  harassmentRecords,
  otherRecords,
  sexOffenseRecords,
  societalRecords,
  theftOffenseRecords,
  violentRecords
} from "shared/app/VerificationTemplate/slices/DecisionCriteria/slices/RuleCriteria/constants";
import {
  FieldName,
  Rule
} from "shared/app/VerificationTemplate/slices/DecisionCriteria/slices/RuleCriteria/types";
import { formatTitleFirstWord } from "utils/formatTitle";
import { readableFieldName } from "./constants";

const fieldsWithSubcategory = [
  FieldName.FelonyRecords,
  FieldName.MisdemeanorRecords,
  FieldName.OtherCriminalRecords,
  FieldName.AllCriminalRecords
];

export const formatThreshold = (rule: Rule) => {
  if (
    [FieldName.SexOffenderCheck, FieldName.IncomeDocumentFraudCheck].includes(
      rule.field_name
    )
  )
    return rule.threshold === 1 || rule.threshold === "1" ? "Yes" : "No";
  else
    return rule.threshold === "true"
      ? "Yes"
      : rule.threshold === "false"
        ? "No"
        : rule.threshold || "-";
};

export const formatConditionTitle = (field_name: FieldName) => {
  if (field_name === FieldName.OfacRecords)
    return "Sanctions (OFAC) convictions";

  const hasSubcategory = fieldsWithSubcategory.find((key) =>
    field_name.includes(key)
  );

  if (hasSubcategory) {
    const subcategories = {
      ...drugRecords(hasSubcategory),
      ...violentRecords(hasSubcategory),
      ...sexOffenseRecords(hasSubcategory),
      ...theftOffenseRecords(hasSubcategory),
      ...destructionRecords(hasSubcategory),
      ...harassmentRecords(hasSubcategory),
      ...societalRecords(hasSubcategory),
      ...conspiracyOrganizedRecords(hasSubcategory),
      ...corporateRecords(hasSubcategory),
      ...otherRecords(hasSubcategory)
    };

    const currentSubcategory = subcategories[field_name] || "";

    return (
      `${formatTitleFirstWord(hasSubcategory).replaceAll("records", "convictions")}` +
      "   " +
      `${currentSubcategory.toLowerCase()}`
    );
  }

  return readableFieldName[field_name];
};

export const formatApplicantValue = (rule: Rule, value: string | number) => {
  if (
    [FieldName.SexOffenderCheck, FieldName.IncomeDocumentFraudCheck].includes(
      rule.field_name
    )
  )
    return value === 1 || value === "1" ? "Yes" : "No";
  else return String(value);
};
